export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',

  // 概览
  'menu.overview': '平台总览',
  'menu.overview.overview-index': '平台总览',
  'menu.dashboard.overview': '平台总览',
  'menu.dashboard.overview-index': '平台总览',
  'menu.dashboard.admin-dashboard': '管理统计',

  // 用户与商户
  'menu.user-merchant': '用户与商户',
  'menu.user-merchant.user-management': '用户管理',
  'menu.user-merchant.merchant-management': '商户管理',
  'menu.user-merchant.yellowpage-audit': '黄页审核',

  // 内容管理
  'menu.content-management': '内容管理',
  'menu.yellowpage-management': '黄页管理',
  'menu.content-management.yellowpage-management': '黄页管理',
  'menu.content-management.post-management': '动态管理',
  'menu.content-management.demand-management': '需求管理',
  'menu.content-management.comment-management': '评论管理',
  'menu.content-management.help-center-management': 'FAQ 管理',

  // 置顶管理
  'menu.pin-management': '置顶管理',
  'menu.pin-management.pin-yellowpage': '黄页置顶',
  'menu.pin-management.pin-post': '动态置顶',

  // 交易管理
  'menu.transaction-ads': '交易管理',
  'menu.transaction-ads.order-management': '订单管理',
  'menu.transaction-ads.payment-management': '支付管理',
  'menu.transaction-ads.ad-management': '广告管理',
  'menu.transaction-ads.merchant-balance-management': '商户余额管理',
  'menu.transaction-ads.discount-code-management': '折扣码管理',
  'menu.transaction-ads.discount-code-usage': '折扣码使用记录',

  // 会员管理
  'menu.membership': '会员管理',
  'menu.membership.member-level': '会员等级',
  'menu.membership.benefit-config': '权益配置',
  'menu.membership.merchant-member-state': '商户会员状态',

  // AI管理
  'menu.ai-management': 'AI 管理',
  'menu.ai-management.ai-role': 'AI角色管理',
  'menu.ai-management.quota-config': '配额配置',
  'menu.ai-management.ai-logs': '调用日志',

  // 消息与合规管理
  'menu.compliance-management': '消息与客服管理',
  'menu.compliance-management.feedback': '客服管理',
  'menu.compliance-management.complaint': '申诉管理',
  'menu.compliance-management.message-management': '消息管理',
  'menu.compliance-management.customer-service-management': '客服管理',
  'menu.compliance-management.sensitive-words': '敏感词管理',
  'menu.compliance-management.announcement': '平台公告',

  // 权限与管理员
  'menu.permission-admin': '权限与管理员',
  'menu.permission-admin.perm-management': '角色管理',
  'menu.permission-admin.permission-management': '权限管理',
  'menu.permission-admin.admin-accounts': '管理员账号',

  // 其他配置
  'menu.other-settings': '平台配置',
  'menu.other-settings.system-config': '系统配置',
  'menu.other-settings.city-management': '城市管理',
  'menu.other-settings.industry-management': '行业管理',
  'menu.other-settings.about-us': '关于我们',
  'menu.other-settings.privacy-policy': '隐私政策',
  'menu.other-settings.user-agreement': '服务条款',

  // 默认模板菜单（保留以兼容）
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
